'use client';

import React from "react";
import "./Footer.css";
import Logo from "../Header/Logo/Logo";
import strings from "../../config/App.json";
import SocialIcons from "../SocialIcons/SocialIcons";
import Link from "next/link";
import CommunityJoinBar from "./CommunityJoinBar";
import { Business_bottomAd } from "../Ads/businessAds";

const Footer = () => {
  return (
    <>
      <div>
        <CommunityJoinBar />
      </div>
      <div className="footer-background">
        <footer className="footer">
          <div className="footer-content">
            <div className="footer-icons">
              <Logo />
              <SocialIcons />
            </div>
            <div className="footer-links">

              <Link
                href='https://www.thefiscaloracle.com/brutto-netto-rechner'
                target="_blank"
                rel="noopener noreferrer"
                className="nav-links"
              >
                Salary Calculator
              </Link>
              <Link href={strings.AboutPage}>About</Link>
              <Link href={strings.PrivacyPolicy}>Privacy Policy</Link>
              <Link href={strings.Impressum}>Impressum</Link>
              <Link href={strings.DisclaimerPage}>Disclaimer</Link>
              <Link href={strings.ContactPage}>Contact</Link>
            </div>

            <div className="footer-rights">
              <p className="copyright">© munichindians {new Date().getFullYear()}. All Rights Reserved.</p>
              <p className="design-credit">
                Designed by{" "}
                <a
                  href="https://husali.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="husali"
                >
                  <span className="company-name">Husali Technologies Pvt. Ltd.</span>
                </a>
              </p>
            </div>
          </div>
        </footer>
      </div>
      <Business_bottomAd />
    </>
  );
};

export default Footer;
